import createClient, { type ClientOptions } from "openapi-fetch";

import type { components, operations, paths } from "./generated/schema";

export { normalizeApiError } from "./errors";
export type { ApiError } from "./errors";
export {
  AdminUploadError,
  adminPreviewUrl,
  uploadAdminMultipart,
  uploadAdminProductFile,
} from "./admin-upload";
export type {
  AdminMultipartUploadOptions,
  AdminUploadOptions,
  AdminUploadProgress,
  AdminUploadResponse,
} from "./admin-upload";
export type { components, operations, paths };

export type ApiClientOptions = Pick<ClientOptions, "baseUrl" | "fetch">;

export function createApiClient(options: ApiClientOptions = {}) {
  return createClient<paths>({
    baseUrl: "/api",
    ...options,
  });
}

type ApiClient = ReturnType<typeof createApiClient>;

let defaultApiClient: ApiClient | undefined;

function getDefaultApiClient(): ApiClient {
  return (defaultApiClient ??= createApiClient());
}

export const apiClient: ApiClient = new Proxy({} as ApiClient, {
  get(_target, property) {
    const client = getDefaultApiClient() as unknown as Record<PropertyKey, unknown>;
    return client[property];
  },
});
